<template>
  <b-modal id="update-customer-email-modal" no-close-on-backdrop no-stacking ref="update-customer-email-modal" @hidden="resetModal" @close="resetModal">
    <template slot="modal-title"> {{ $t('updateCustomerEmail') }}</template>
    <form ref="form" v-on:submit.prevent>
      <b-row class="mb-4">
        <b-col>
          <p>{{ $t('updateCustomerEmailDetails') }}</p>
        </b-col>
      </b-row>
      <b-row class="mb-4">
        <b-col cols="4">{{ $t('email') }}</b-col>
        <b-col>
          <b-form-input type="text" v-model="updateRequest.customerEmail"/>
        </b-col>
      </b-row>
    </form>

    <div slot="modal-footer" class="col-md-12">
      <b-button variant="primary" class="float-lg-right" @click="updateEmail" :disabled="disableUpdateButton">{{ $t('update') }}</b-button>
      <b-button variant="secondary" class="float-lg-left" v-on:click="resetModal">{{ $t('cancel') }}</b-button>
    </div>
  </b-modal>
</template>


<script>
  export default {
    data() {
      return {
        updateRequest: {
          customerEmail: null
        }
      }
    },
    computed: {
      disableUpdateButton () {
        return (this.updateRequest.customerEmail === null)
      }
    },
    methods: {
      updateEmail() {
        let that = this
        this.$store.dispatch('orders/updateCustomerEmail', {
          orderId: this.$route.params.id,
          updateRequest: this.updateRequest
        }).then(function () {
          that.$root.$emit('bv::hide::update-customer-email-modal', 'confirmation')
          that.resetModal()
        })
      },
      resetModal() {
        this.updateRequest.customerEmail = null
        this.$refs['update-customer-email-modal'].hide()
      }
    }
  }
</script>
